export default __webpack_public_path__ + "static/media/logo4.17cf3bc5.png";